import {
  differenceInDays,
  format,
  isSameDay,
  isSameYear,
  isYesterday,
  isTomorrow,
  startOfDay,
} from "date-fns";

export function formatDateSmart(date: Date): string {
  const today = startOfDay(new Date());
  const target = startOfDay(date);

  if (isSameDay(target, today)) {
    return "Today";
  }

  if (isTomorrow(target)) {
    return "Tomorrow";
  }

  if (isYesterday(target)) {
    return "Yesterday";
  }

  const diff = differenceInDays(target, today);

  // 2–7 days ahead: "Next Wednesday"
  if (diff >= 2 && diff <= 7) {
    return `Next ${format(target, "EEEE")}`;
  }

  // 8–14 days ahead: "In N days"
  if (diff >= 8 && diff <= 14) {
    return `In ${diff} days`;
  }

  // Same year: "Mon, Feb 14"
  if (isSameYear(target, today)) {
    return format(target, "EEE, MMM d");
  }

  // Different year: "Mon, Feb 14, 2026"
  return format(target, "EEE, MMM d, yyyy");
}
